import { ILocationItem } from '../../types/buildersLocations';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EBuildersLocationsActionType, TSetBuildersLocationsData } from './types';

export const setLocationsData: (data: ILocationItem[]) => TSetBuildersLocationsData = actionGenerator<
  EBuildersLocationsActionType.SetData,
  ILocationItem[]
>(EBuildersLocationsActionType.SetData);
